/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import { statusStr, xsdPathStr } from "../../../globals/constants";
import StatusIcon from "../../Shared/Status/StatusIcon";
import { IConfigStatus, ILanDevice } from "../../../store/api/deviceConfig/types";
import { cconfigStatusDataSelector } from "../../../store/api/deviceConfig/selectors";
import { useSelector } from "react-redux";

interface ILANDeviceStatusProps {
  tableRow: ILanDevice;
}

const LANDeviceStatus: React.FC<ILANDeviceStatusProps> = ({ tableRow }) => {
  const configStatusData = useSelector(cconfigStatusDataSelector);
  const { lanDevice } = xsdPathStr;
  const configStatus =
    configStatusData.length > 0
      ? configStatusData.filter((item: IConfigStatus) => item.rowKey === tableRow.index && item.tableId === `${lanDevice.tableId}.${tableRow.index}`)
      : [];
  const currentStatus = !!configStatus && configStatus.length > 0 ? configStatus[0]?.status : tableRow.status;
  return (
    <>
      <StatusIcon status={statusStr.includes(currentStatus) ? "InProgress" : currentStatus} />
    </>
  );
};
export default LANDeviceStatus;
